import { render, staticRenderFns } from "./izin.vue?vue&type=template&id=21668153"
import script from "./izin.vue?vue&type=script&lang=js"
export * from "./izin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports